import { createContext, useContext } from "react";

/**
 * Context value for CheckboxGroup
 * @property {boolean} hasError - Whether the group has an error state
 */
export type CheckboxGroupContextValue = {
  /**
   * Whether the checkbox group has an error state
   */
  hasError: boolean;
};

/**
 * Context for sharing state between CheckboxGroup and child Checkbox components
 */
export const CheckboxGroupContext = createContext<
  CheckboxGroupContextValue | undefined
>(undefined);

/**
 * Hook to access CheckboxGroup context from child Checkbox components
 * @returns CheckboxGroupContextValue if inside a CheckboxGroup, undefined otherwise
 */
export const useCheckboxGroupContext = () => {
  return useContext(CheckboxGroupContext);
};
